import { keepPreviousData, useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { makeCRMApi } from '../CrmApi';
import { AxiosError, AxiosResponse } from 'axios';
import { ISearchActivityRequest, ISearchActivityResponse } from '../types/CrmActivityTypes';

export const useCrmActivities = (searchRequest: ISearchActivityRequest, shouldMakeRequest: boolean) => {
  const crmApi = makeCRMApi();

  const crmActivities = useInfiniteQuery<AxiosResponse<ISearchActivityResponse>, AxiosError>({
    queryKey: ['crm-activities', searchRequest],
    placeholderData: keepPreviousData,
    queryFn: ({ pageParam = 0 }) => {
      const request: ISearchActivityRequest = {
        ...searchRequest,
        pagination: { ...searchRequest.pagination, offset: typeof pageParam === 'number' ? pageParam : 0 },
      };
      if (pageParam !== 0) {
        delete request.cursor;
      }
      return crmApi.searchActivity(request);
    },
    enabled: shouldMakeRequest,
    retry: false,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.data.list.length < searchRequest.pagination.limit) {
        return undefined;
      }
      const itemsLength = allPages.flatMap(item => item.data.list).length;
      return itemsLength;
    },
    staleTime: 1000,
  });

  return {
    activities: crmActivities.data?.pages?.flatMap(item => item.data.list) ?? [],
    crmActivities: crmActivities,
  };
};
